import {Routes, Route, useNavigationType, useLocation} from "react-router-dom";
import React, {useEffect} from "react";
import * as Pages from "@adminPages";
import {AdminScreenId} from "@assets";
import {useLogin} from "@hook";

interface IRoute {
  path: AdminScreenId;
  element: JSX.Element;
}
const initRouteList: IRoute[] = [
  {path: AdminScreenId.REVIEW_LIST, element: <Pages.ReviewPage />},
  {path: AdminScreenId.REVIEW_DETAIL, element: <Pages.ReviewDetailPage />},
];

export default function AdminRouteApp() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== "POP") window.scrollTo(0, 0);
  }, [action, pathname]);

  return (
    <Routes>
      <Route
        path="/"
        element={(initRouteList || [])[0]?.element || <Pages.ErrorPage />}
      />
      {initRouteList.map((_route, i) => (
        <Route
          key={i}
          path={`/${removePrefixIfStartsWith({
            text: _route.path,
            prefix: "/admin",
          })}`}
          element={_route.element}
        />
      ))}
      <Route path="*" element={<Pages.ErrorPage />} />
    </Routes>
  );
}

function removePrefixIfStartsWith({
  text,
  prefix,
}: {
  text: string;
  prefix: string;
}) {
  if (text.startsWith(prefix)) {
    return text.replace(prefix, "");
  }
  return text;
}
